var $resultTable = null;

$(document).ready(function() {
	$resultTable = $('#link-table div.item');
	
	hotelSearchFilter.init();
});

var hotelSearchFilter = function() {
	var $nameFilter = $("#filterByName");
	var $stars = $(".filterByStar");
	var $boards = $(".filterByBoard");
	
	this.init = function (){
		$("#filterByName").keyup(function() {
			applyFilter();
		});
		
		$(".filterByStar").click(function() {
			applyFilter();
			$('#btnResetFilter').removeClass('opacity-50');
		});

		$(".filterByBoard").click(function() {
			applyFilter();
			$('#btnResetFilter').removeClass('opacity-50');
		});
		
		if($resultTable != null){
			var minPrice = $($resultTable.first()).attr("price");
			var maxPrice = $($resultTable.last()).attr("price");
			var minSliderValue = parseInt(minPrice / 10, 10) * 10;
			var maxSliderValue = parseInt(maxPrice / 10, 10) * 10 + 10;
			
			$('#minPrice').val(minSliderValue);
			$('#minPrice').attr('min',minSliderValue);
			$('#minPrice').attr('max',maxSliderValue);
			$('#maxPrice').val(maxSliderValue);
			$('#maxPrice').attr('min',minSliderValue);
			$('#maxPrice').attr('max',maxSliderValue);
			
			$("#minPrice, #maxPrice").on('change',function(){
				applyFilter();
				$('#btnResetFilter').removeClass('opacity-50');
			});
		}
		
		$("#btnResetFilter").click(function() {
			$('#minPrice').val($('#minPrice').attr('min'));
			$('#maxPrice').val($('#maxPrice').attr('max'));
			$('.filterByStar').prop("checked", true);
			$('.filterByBoard').prop("checked", true);
			$(this).addClass('opacity-50');
			applyFilter();
		});
	}
	
	this.applyFilter = function() {
		var filter = getFilter();
		$resultTable.each(function(index, item){
			var show = isMatchesFilter(item, filter);
			if(show){
				$(item).show();
			}
			else{
				$(item).hide();
			}
		});
	}
	
	var getFilter = function(){
		var stars = {}
		$stars.each(function(index, item){
			stars[item.value] = $(item).prop("checked");
		});

		var boards = {}
		$boards.each(function(index, item){
			boards[item.value] = $(item).prop("checked");
		});
		
		return {
			minprice : parseInt($("#minPrice").val()),
			maxprice : parseInt($("#maxPrice").val()),
			name : $nameFilter.val().toLocaleLowerCase("tr-TR"),
			stars : stars,
			boards : boards
		}
	}
	
	function _fnEscapeRegex ( sVal ) {
		var letters = { "İ": "[İi]", "I": "[İi]", "Ş": "[Şş]", "Ğ": "[Ğğ]", "Ü": "[Üü]", "Ö": "[Öö]", "Ç": "[Çç]", "i": "[İi]", "ı": "[İi]", "ş": "[Şş]", "ğ": "[Ğğ]", "ü": "[Üü]", "ö": "[Öö]", "ç": "[Çç]" };
		return sVal.replace(/(([İIŞĞÜÇÖiışğüçö]))/g, function (letter) { return letters[letter]; });
	}

	var isMatchesFilter = function(item, filter){
		if(filter.name.length > 0){
			var _name = _fnEscapeRegex(filter.name);
			var itemName = _fnEscapeRegex($(item).attr("hotelname").toLocaleLowerCase("tr-TR"));

			if(itemName.indexOf(_name) < 0){		
				return false;
			}
		} 
		
		if($(item).attr("star") in filter.stars && !filter.stars[$(item).attr("star")]){
			return false;
		}
		
		var boardlistItems = $(item).attr("boardlist");
		if(boardlistItems){
			var propertyList = boardlistItems.split(",");
			for(var pIndex in propertyList){
				if(propertyList[pIndex] in filter.boards && !filter.boards[propertyList[pIndex]]){
					return false;
				}
			}
		} else {
			return false;
		}
		
		if(filter.minprice > $(item).attr("price") || filter.maxprice < $(item).attr("price")) {
			return false;
		}
		
		return true;
	}
	
	return {
		init : init
	}
}();